import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "What is DePIN?",
    answer: "DePIN (Decentralized Physical Infrastructure Networks) refers to blockchain based protocols that incentivize the creation and maintenance of real world infrastructure. This includes wireless networks, energy grids, computing resources, and more all powered by community participation and token rewards."
  },
  {
    question: "How can I participate in DePIN projects?",
    answer: "You can participate by deploying hardware nodes (like hotspots, sensors, or computing devices), contributing to network growth, or investing in DePIN tokens. DePIN Land provides education, resources, and community support to help you get started with projects suited to your interests and resources."
  },
  {
    question: "What makes DePIN different from traditional infrastructure?",
    answer: "Unlike traditional infrastructure controlled by centralized corporations, DePIN distributes ownership and rewards among community participants. This creates more resilient, cost-effective networks while enabling individuals to earn passive income by contributing resources."
  },
  {
    question: "Is DePIN available in Africa?",
    answer: "Yes! DePIN Land focuses specifically on bringing decentralized infrastructure opportunities to Africa. Many DePIN projects are actively expanding into African markets, and our community helps members navigate local regulations and opportunities."
  },
  {
    question: "What kind of returns can I expect from DePIN participation?",
    answer: "Returns vary significantly based on the project, your contribution level, and market conditions. Some participants earn passive income through token rewards, while others benefit from network growth and token appreciation. We recommend thorough research and starting with projects that match your risk tolerance."
  },
  {
    question: "How do I join the DePIN Land community?",
    answer: "Joining is easy! Connect with us on Discord or Twitter to access our community resources, educational content, and networking opportunities. We host regular workshops, AMAs, and local meetups to help members learn and grow together."
  }
];

const FAQSection = () => {
  return (
    <section className="py-16 md:py-24 relative overflow-hidden">
      <div className="container mx-auto px-4 max-w-4xl">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Everything you need to know about DePIN and how to get started
          </p>
        </motion.div>

        {/* FAQ Accordion */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <Accordion type="single" collapsible className="w-full space-y-3">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border border-border/50 rounded-xl px-6 bg-card/50 backdrop-blur-sm hover:bg-muted/30 transition-colors data-[state=open]:bg-muted/30"
              >
                <AccordionTrigger className="text-left text-base md:text-lg font-medium text-foreground hover:no-underline py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-sm md:text-base leading-relaxed pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>

        {/* Bottom CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <p className="text-muted-foreground">
            Still have questions?{" "}
            <a
              href="https://discord.gg/paEy3nMcuH"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:underline font-medium"
            >
              Join our Discord community
            </a>
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQSection;
